import ChatBubble from './chat-bubble';

export default ChatBubble;
